import {
  setUserLoginInfo,
  getUserLoginInfo,
  removeUserLoginInfo, setToken, removeToken
} from "@/utils/auth";
import {
  resetRouter
} from "@/router";
import { login, logout } from "@/api/login.js";
const getDefaultState = () => {
  return {
    userInfo: getUserLoginInfo(),
  };
};

const state = getDefaultState();

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, {});
  },
  SET_USER: (state, user) => {
    state.userInfo = user;
  },
};

const actions = {
  // user login
  login({
    commit
  }, userInfo) {
    // 登录
    return new Promise((resolve, reject) => {
      try {
        login(userInfo).then(res => {
          setToken(res);
          let info = {
            username: userInfo.username
          };
          setUserLoginInfo(info)
          commit("SET_USER", info);
          resolve();
        }, (error) => {
          reject(error)
        })
      } catch (error) {
        reject(error)
      }
    });
  },
  // user logout
  logout({
    commit,
    state
  }) {
    return new Promise((resolve, reject) => {
      try {
        // logout().then(() => {
          removeToken();
          resetRouter();
          removeUserLoginInfo();
          commit("RESET_STATE");
          resolve();
          window.location.href = "/";
        // })
      } catch (error) {
        reject(error)
      }
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
